<template>
  <!-- 진행 단계 카드(1688배송·쿠패스·쿠팡입고·국내창고) — 商品求购 위에 있던 것을 订单列表 위로 옮겼다(2026-10-07 YZY 선택 B).
       숫자는 订单列表 목록(결제 후 입고 전)이 아니라 **전체 구매요청** 기준 — 商品求购 에서 같은 기간·업체로 「待采购」 끄고 검색한 카드 숫자와 같다.
       누르면 商品求购 로 가서 그 진행현황으로 걸러 보여준다(쿼리 stage·start·end·companyid).
       paid 모드(订单列表, 2026-10-07 YZY 2차): 숫자 = 그 단계의 **결제완료 건**(订单列表 목록과 같은 조건),
       누르면 이동하지 않고 select 이벤트로 订单列表 안에서 거른다. 다시 누르거나 ✕ 면 select('') = 기본(미입고·미처리) -->
  <div class="stage-cards">
    <div v-for="g in groups" :key="g.key" class="filter-group">
      <span class="filter-group__title">{{ g.icon }} {{ g.zh }}<br><small class="text-muted">{{ g.ko }}</small></span>
      <div class="filter-group__buttons">
        <b-button v-for="s in g.items" :key="s.value"
          :variant="active === s.value ? 'primary' : (counts[s.value] ? s.outline : 'outline-light')"
          size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !counts[s.value] && active !== s.value }"
          :disabled="loading" @click="go(s.value)">
          <span>{{ s.zh }}<br><small>{{ s.ko }}</small></span>
          <b-badge :variant="active === s.value ? 'light' : (counts[s.value] ? s.badge : 'light')">{{ loading ? '…' : (counts[s.value] || 0) }}</b-badge>
        </b-button>
      </div>
    </div>
    <b-button v-if="paid && active" size="sm" variant="outline-danger" class="filter-btn align-self-center" @click="$emit('select', '')">
      ✕ 默认(未入库·未处理)<br><small>기본 보기(미입고·미처리)</small>
    </b-button>
  </div>
</template>

<script>
import axios from 'axios';

// 商品求购(logisreqpurchaseV0) 진행현황 필터 그룹 중 결제 뒤 단계 — 값·라벨·색은 그 화면에 있던 그대로
const GROUPS = [
  { key: '1688', icon: '📦', zh: '1688物流', ko: '1688배송', items: [
    { value: '배송중', zh: '运输中', ko: '배송중', badge: 'secondary' },
    { value: '배송완료', zh: '已签收', ko: '배송완료', badge: 'success' }
  ] },
  { key: 'coupass', icon: '🏭', zh: 'COUPASS仓库', ko: '쿠패스', items: [
    { value: '입고작업', zh: '入库作业中', ko: '입고작업', badge: 'secondary' },
    { value: '출고확인대기', zh: '待确认出库', ko: '출고확인대기', badge: 'secondary' },
    { value: '재고대기', zh: '待上架库存', ko: '재고대기', badge: 'secondary' },
    { value: '출고대기', zh: '待出库', ko: '출고대기', badge: 'secondary' },
    { value: '출고완료', zh: '已出库', ko: '출고완료', badge: 'success' },
    { value: '중국재고', zh: '中国库存', ko: '중국재고', badge: 'dark' },
    { value: '출고요청', zh: '📦出库申请', ko: '출고요청', badge: 'warning', outline: 'outline-warning' },
    { value: '입고오류', zh: '⚠️入库错误', ko: '입고오류', badge: 'danger', outline: 'outline-danger' }
  ] },
  { key: 'coupang', icon: '🚢', zh: '酷澎入库', ko: '쿠팡입고', items: [
    { value: '해외입고중', zh: '海外入库中', ko: '해외입고중', badge: 'secondary' },
    { value: '국내입고중', zh: '韩国入库中', ko: '국내입고중', badge: 'secondary' },
    { value: '쿠팡센터입고완료', zh: '酷澎中心入库完成', ko: '쿠팡센터입고완료', badge: 'success' }
  ] },
  { key: 'kr', icon: '🏭', zh: '韩国仓库', ko: '국내창고', items: [
    { value: '국내창고입고중', zh: '入库中', ko: '입고중', badge: 'secondary' },
    { value: '국내창고입고완료', zh: '入库完成', ko: '입고완료', badge: 'success' }
  ] }
].map(g => ({ ...g, items: g.items.map(s => ({ outline: 'outline-secondary', ...s })) }));

export default {
  name: 'CoupassStageCards',
  props: {
    // 요청일 범위 'YYYY-MM-DD' — 商品求购 의 求购日期 와 같은 뜻
    startdate: { type: String, default: '' },
    enddate: { type: String, default: '' },
    companyid: { type: String, default: '' },
    // 订单列表 용 — 결제완료 건만 세고(서버 stageCounts paid), 누르면 이동 대신 select 이벤트
    paid: { type: Boolean, default: false },
    // 지금 걸려 있는 단계(paid 모드) — 강조 표시
    active: { type: String, default: '' }
  },
  data() {
    return { groups: GROUPS, counts: {}, loading: false, seq: 0 };
  },
  methods: {
    // 商品求购 search() 와 같은 시각 계산(한국 날짜 0시 ~ 끝날 23:59:59.999)
    // paid 모드는 订单列表(서버 paidlist)과 같은 중국 날짜(+08:00) 0시 ~ 23:59:59.999
    range() {
      if (this.paid) {
        return {
          start: new Date(this.startdate + 'T00:00:00+08:00').getTime(),
          end: new Date(this.enddate + 'T23:59:59.999+08:00').getTime()
        };
      }
      const day = 24 * 60 * 60 * 1000, kst = 9 * 60 * 60 * 1000;
      const s = new Date(this.startdate).getTime() - kst;
      const e = new Date(this.enddate).getTime() + day - kst - 1;
      return { start: s, end: e };
    },
    // 부모가 검색할 때 부른다(订单列表 의 날짜·업체를 그대로 쓴다)
    async load() {
      const { start, end } = this.range();
      if (!Number.isFinite(start) || !Number.isFinite(end)) return;
      const my = ++this.seq;
      this.loading = true;
      try {
        const { data } = await axios.post('/api/reqpurchase/stageCounts', { start, end, companyid: this.companyid, ...(this.paid ? { paid: true } : {}) });
        if (my !== this.seq) return;
        if (data.요청결과 !== '성공') {
          console.error('진행 단계 카드 집계 실패:', data.error);
          this.counts = {};
          return;
        }
        this.counts = data.counts || {};
      } catch (e) {
        console.error('진행 단계 카드 집계 오류:', e);
      } finally {
        if (my === this.seq) this.loading = false;
      }
    },
    go(stage) {
      // 订单列表 안에서 거른다 — 같은 카드를 다시 누르면 해제
      if (this.paid) {
        this.$emit('select', this.active === stage ? '' : stage);
        return;
      }
      this.$router.push({
        name: 'logis.logisreqpurchaseV0',
        query: { stage, start: this.startdate, end: this.enddate, ...(this.companyid ? { companyid: this.companyid } : {}) }
      }).catch(e => { if (e && e.name !== 'NavigationDuplicated') console.error('[订单列表] 商品求购 이동 실패', e); });
    }
  }
};
</script>

<style scoped>
/* 商品求购 필터 그룹과 같은 모양(그 화면 스타일은 그 화면이 열렸을 때만 실리므로 여기 따로 둔다) */
.stage-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.5rem;
  margin-bottom: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #c4c4c4;
}
.filter-group {
  background: #fff;
  border-radius: 6px;
  padding: 0.4rem 0.6rem;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.filter-group__title {
  font-weight: 600;
  font-size: 0.85rem;
  color: #495057;
  white-space: nowrap;
  margin-right: 0.5rem;
  line-height: 1.3;
}
.filter-group__title small {
  font-weight: 400;
  font-size: 0.7rem;
}
.filter-group__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  align-items: stretch;
}
.filter-btn {
  font-size: 0.85rem !important;
  padding: 0.25rem 0.5rem !important;
  border-radius: 8px !important;
}
.filter-btn .badge {
  font-size: 0.75rem;
  padding: 0.15em 0.4em;
  margin-left: 0.2rem;
}
.filter-btn--bilingual {
  display: inline-flex;
  align-items: center;
  text-align: left;
  line-height: 1.2;
}
.filter-btn--bilingual small {
  font-size: 0.65rem;
  opacity: 0.7;
}
.filter-btn--dim {
  opacity: 0.4;
}
.filter-btn--dim:hover {
  opacity: 0.7;
}
.btn-outline-light {
  border-color: #dee2e6;
  color: #adb5bd;
}
</style>
